import { z } from "zod";

export const useRequestPasswordResetForm = () => {
    const schema = z.object({
        email: z.string().email(),
    });

    return { schema };
}